// extracted by mini-css-extract-plugin
module.exports = {"leftContent":"leftContent-3wp6eqUf","artical":"artical-2fkrRMjO","cmt":"cmt-Fv55D9eJ"};